import BaseService from './BaseService'

class TermsService extends BaseService {
  constructor() {
    super('/terms')
  }

  getDefault() {
    return this.customRequest('get', '/default')
  }
}

export default new TermsService()


